 /* eslint-disable */
import React, { useState } from 'react'
import { Route,  useRouteMatch, Redirect,NavLink } from 'react-router-dom'
import { useWallet } from 'use-wallet'
import styled from 'styled-components'
import chef from '../../assets/img/chef.png'
import Button from '../../../components/Button'
import Container from '../../../components/Container'
import Page from '../../../components/Page'
import Toggle from '../../../components/Toggle'

import Loader from '../../../components/Loader'
import CardTitle from '../../../components/CardTitle'
import CardContent from '../../../components/CardContent'
import useLod from '../../../hooks/useLod'
import useClaim from '../../../hooks/useClaim'
import useModal from '../../../hooks/useModal'
import WalletProviderModal from '../../../components/WalletProviderModal'
//import { ProposalEntry, StyledDescription, StyledState, StyledButton, StyledProposalContentInner } from "./components/Proposal";
import SeparatorGrid from "./SeparatorWithCSS";
import Box from "./BoxWithDisplay";
import CardIcon from '../../../components/CardIcon'
import Separator from "../../../components/Separator";
import useMyInsurances from '../../../hooks/useMyInsurances'
import { convertUnixToDate } from '../../../lod/utils'

const getStatus = (status: string)=>{
  if(status === '0')
  {
    return  "Trading"
  }else if(status === '1'){
    return  "Payingout"
  }else{
    return "Paused"
}
} 

const MyInsurances: React.FC = () => {
  const { path } = useRouteMatch()
  const [active, setActive] = useState(true)
  const [txId, setTxId] = useState(0)
  const [onPresentWalletProviderModal] = useModal(<WalletProviderModal />)
  const lod = useLod()
  const { account }: { account: any; ethereum: any } = useWallet()
  const { onClaim } = useClaim()
  const myInsuranceHoldings = useMyInsurances()
  console.log(myInsuranceHoldings)
  const validateEgligible =  (insurance:any) => {
    const target = insurance.target.value
    return !insurance.payoutTargets.includes(target) 
  }

  const validateTargetStart =  (insurance:any) => {
    const target = insurance.incident.incidentTimestamp
    return target <= insurance.startTime 
  }

  const validateTargetEnd =  (insurance:any) => {
    const target = insurance.incident.incidentTimestamp
    return target > insurance.endTime
  }
  
  return (
    <StyledWrapper>
      <StyledShell>
        <StyledMenu>
          <Box display="grid" alignItems="center" row>
            <StyledSubjectInner>
              <StyledDescription>
                Protocol
              </StyledDescription>
              <StyledDescription>
                ID
              </StyledDescription>
              <StyledDescription>
                Pool
              </StyledDescription>
              <StyledDescription>
                Amount
              </StyledDescription>
              <StyledDescription>
                Period
              </StyledDescription>
              <StyledDescription>
                Action
              </StyledDescription>
            </StyledSubjectInner>
          </Box>
        </StyledMenu>
      {myInsuranceHoldings.length > 0 ? (
      <>
        {myInsuranceHoldings.length === 1 && myInsuranceHoldings[0] ==='nodata'?
        (  
        <div>
          <Separator />
          <CardContent>
            <Box display="grid" alignItems="center" row>
                <StyledLoadingWrapper>
                You have no insurances
                </StyledLoadingWrapper>
            </Box>
          </CardContent>
        </div>
        ):
        (
          <>
            {myInsuranceHoldings.map((insurance, j) => (
              <React.Fragment key={j}>
                <Separator />
                <CardContent>
                  <Box display="grid" alignItems="center" row>
                  <StyledSubjectInner>
                      <StyledProtocol >
                        <StyledImg src={require(`../../../assets/img/${insurance.icon}.png`)} />
                        <StyledActionSpacer/>
                        <StyledInfo >
                          {insurance.name}
                        </StyledInfo>
                      </StyledProtocol >      
                      <StyledInfo >
                        {insurance.id}
                      </StyledInfo>
                      <StyledInfo >
                        {insurance.target.label}
                      </StyledInfo>
                      <StyledInfo >
                      {`${(insurance.amount /(10 ** insurance.tokenDecimal)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})} ${insurance.tokenSymbol}`}
                      </StyledInfo>
                      <StyledInfo >
                        {`${insurance.start} ~ ${insurance.end}`}
                      </StyledInfo>
                      <StyledButton>
                        {insurance.marketstat === "0"?(
                          <>
                          {!insurance.live?(
                            <StyledInfo >
                              Expired
                            </StyledInfo>
                          ):(
                            <>
                            {insurance.unclaimed?(
                            <Button
                              disabled={true}
                              text={txId === insurance.pid+insurance.id ? 'Redeeming..' : 'Redeem'}
                              onClick={async () => {
                                setTxId(insurance.pid+insurance.id)
                                await onClaim(insurance.id, insurance.pid)
                                setTxId(0)
                              }}
                              size={'sm'}
                            />
                            ):(
                              <StyledInfo >
                                Redeemed
                              </StyledInfo>
                            )}
                            </>
                          )}
                          </>
                        ):(
                          <>
                          {validateTargetEnd(insurance)?(
                            <StyledInfo >
                              Expired
                            </StyledInfo>
                          ):(
                            <>
                            {insurance.unclaimed?(
                            <Button
                              disabled={ validateTargetStart(insurance) ||  validateEgligible(insurance)|| insurance.marketstat !== '1' || txId === insurance.pid+insurance.id}
                              text={txId === insurance.pid+insurance.id ? 'Redeeming..' : 'Redeem'}
                              onClick={async () => {
                                setTxId(insurance.pid+insurance.id)
                                await onClaim(insurance.id, insurance.pid)
                                setTxId(0)
                              }}
                              size={'sm'}
                            />
                            ):(
                              <StyledInfo >
                                Redeemed
                              </StyledInfo>
                            )}
                            </>
                          )}
                          </>
                        )}
                      </StyledButton>
                    </StyledSubjectInner>
                  </Box>
                </CardContent>
              </React.Fragment>
            ))}
          </>
        )}
      </>
      ):(
        <div>
        <Separator />
        <CardContent>
          <Box display="grid" alignItems="center" row>
              <StyledLoadingWrapper>
                <Loader/>
              </StyledLoadingWrapper>
          </Box>
        </CardContent>
        </div>
      )}
      </StyledShell>
    </StyledWrapper>
  )
}

interface StyledSeparatorProps {
  gridArea?: string;
}

export const StyledMenu = styled.div`
  padding-left: 16px;
  padding-right: 16px
`;

export const StyledShell = styled.div`
  min-width: 700px;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
`;

export const StyledWrapper = styled.div`
  display: block;
  overflow-x: scroll;S
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
`;

export const StyledSubjectInner = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 25fr 10fr 15fr 15fr 25fr 10fr;
  width:100%
  text-align: center;
  margin-bottom: 5px;
`;

export const StyledIcon = styled.div`
  text-align: left;
  vertical-align: middle;
`;
export const StyledButton = styled.div`
  display: grid;
  @media (max-width: 768px) {
    flex-flow: column nowrap;
    align-items: flex-end;
  }
`;

export const StyledInfo = styled.span<StyledSeparatorProps>`
  display: inline-block;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
`;
export const StyledProtocol = styled.div<StyledSeparatorProps>`
  display: flex;
  align-items: center;
  justify-content: left;
`;


export const StyledDescription = styled.span`
  display: inline-block;
  align-items: center;
  text-align: center;
  font-size: 14px;
`;

const StyledLoadingWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 600;
`


const StyledImg = styled.img`
  alt: '🤔'
  height: 40px;
  width: 40px;
  align-items: left;
`
const StyledActionSpacer = styled.div`
  height: ${(props) => props.theme.spacing[2]}px;
  width: ${(props) => props.theme.spacing[3]}px;
`

const StyledSelect = styled.a`
  color: ${(props) => props.theme.color.grey[300]};
  font-weight: 500;
  padding-left: ${(props) => props.theme.spacing[1]}px;
  padding-right: ${(props) => props.theme.spacing[2]}px;
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.color.main};
  }
  &.active {
    color: ${(props) => props.theme.color.main};
  }
  font-size: 14px;
  @media (max-width: 400px) {
    padding-left: ${(props) => props.theme.spacing[2]}px;
    padding-right: ${(props) => props.theme.spacing[2]}px;
  }
`
const StyledNav = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: ${(props) => props.theme.spacing[4]}px;

`
export default MyInsurances
/*

{proposals && (
  <Surface>
    {proposals.map((prop, i) => {
      if (i == 0) {
        return <ProposalEntry key={prop.hash} prop={prop} onVote={onVote} onRegister={onRegister} />;
      } else {
        return [<Separator />, <ProposalEntry key={prop.hash} prop={prop} onVote={onVote} onRegister={onRegister} />];
      }
    })}
  </Surface>
)}

const MyInsurances: React.FC = () => {
  const { path } = useRouteMatch()
  const [page, setTab] = useState('MyInsurances')
  const [pendingTx, setPendingTx] = useState(false)
  const [onPresentWalletProviderModal] = useModal(<WalletProviderModal />)
  const lod = useLod()
  const { account }: { account: any; ethereum: any } = useWallet()
  const { onClaim } = useClaim()

  const changeTab = (tab:any) =>{
    setTab(tab)
  }
  return (
    <div>
      <Separator />
      <CardContent>
        <Box display="grid" alignItems="center" row>
          <StyledProposalContentInner>
            <StyledDescription>StableCredit cover</StyledDescription>
            <SeparatorGrid orientation={"vertical"} stretch={true} gridArea={"spacer1"} />
            <StyledInfo　gridArea={"amount"} >100 DAI</StyledInfo>
            <SeparatorGrid orientation={"vertical"} stretch={true} gridArea={"spacer2"} />
            <StyledInfo　gridArea={"expire"} >12-Dec-2021</StyledInfo>
            <SeparatorGrid orientation={"vertical"} stretch={true} gridArea={"spacer3"} />
            <StyledInfo　gridArea={"state"} >Trading</StyledInfo>
            <SeparatorGrid orientation={"vertical"} stretch={true} gridArea={"spacer4"} />
        
            <StyledButton>
              <Button>
                Claim
              </Button>
            </StyledButton>
          </StyledProposalContentInner>
        </Box>
      </CardContent>
    </div>
  )
}

interface StyledSeparatorProps {
  gridArea?: string;
}

export const StyledProposalContentInner = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 30fr 5px 20fr 5px 20fr 5px 12fr 5px 18fr;
  grid-template-areas: "title spacer1 amount spacer2 expire spacer3 state spacer4 action";
  grid-template-rows: 100fr;
  @media (max-width: 768px) {
    flex-flow: column nowrap;
  }
`;


export const StyledButton = styled.div`
  display: grid;
  grid-area: action;
  margin-left: 10px;
  justify-content: center;
  @media (max-width: 768px) {
    flex-flow: column nowrap;
    align-items: flex-end;
  }
`;

export const StyledDescription = styled.span`
  display: grid;
  grid-area: title;
  @media (max-width: 768px) {
    flex-flow: column nowrap;
    align-items: flex-start;
  }
`;

export const StyledInfo = styled.span<StyledSeparatorProps>`
  margin-left: 5px;
  margin-right: 5px;
  display: grid;
  grid-area: ${(props) => props.gridArea};
  justify-content: center;
  min-width: 67px;
  @media (max-width: 768px) {
    flex-flow: column nowrap;
    align-items: flex-start;
  }
`;

export const StyledSubject = styled.span`
  justify-content: flex-start;
  font-weight: 600;
`;


export const StyledDetails = styled.span`
  justify-content: flex-start;
`;

export const StyledDetail = styled.span`
  margin-right: 10px;
  font-size: 14px;
  justify-content: flex-start;
`;

        {myInsuranceHoldings.map((insurance, j) => (
          <React.Fragment key={j}>
            <Separator />
            <CardContent>
              <Box display="grid" alignItems="center" row>
                <StyledProposalContentInner>
                  <StyledIcon>
                    <StyledImg src={require(`../../../assets/img/${insurance.icon}.png`)} />
                  </StyledIcon>
                  <StyledInfo >
                    <StyledSubject>{insurance.description}</StyledSubject>
                    <StyledDetails>
                    <StyledDetail>{`Target: ${insurance.target.label}`}</StyledDetail>
                      <StyledDetail>{`Amt: ${insurance.amount /(10 ** insurance.tokenDecimal)} ${insurance.tokenSymbol}`}</StyledDetail>
                      <StyledDetail>{getStatus(insurance.marketstat)}</StyledDetail>
                      <StyledDetail>{`Exp: ${convertUnixToDate(insurance.endTime)}`}</StyledDetail>
                    </StyledDetails>
                  </StyledInfo>
                  <StyledButton>
                    <Button 
                      disabled={insurance.marketstat !== '1' || validateEgligible(insurance)|| txId === insurance.pid+insurance.id}
                      text={txId === insurance.pid+insurance.id ? 'Claiming..' : 'Claim'}
                      onClick={async () => {
                        setTxId(insurance.pid+insurance.id)
                        await onClaim(insurance.id, insurance.pid)
                        setTxId(0)
                      }}
                    />
                     
                  </StyledButton>
                </StyledProposalContentInner>
              </Box>
            </CardContent>
          </React.Fragment>
        ))}


*/